import Card from "@src/@core/components/ui-components/card";
import Flex from "@components/ui-components/flex";
import { LoaderOverlay } from "@components/spinner";
import LoadingButton from "@components/ui-components/loading-button";
import { NoDataComponent } from "@components/no-data-component";
import Paginate from "@src/@core/components/ui-components/paginate";
import { ROW_PER_PAGINATION_OPTIONS } from "@src/utility/constants";
import UpsertNotes from "./upsert";
import capitalize from "lodash/capitalize";
import size from "lodash/size";
import useDateHandler from "@src/utility/hooks/use-date-handler";
import useNotes from "./use-notes";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const Notes = () => {
    const {
        data: { notes, macros, pagination },
        loading,
        getAllNotes,
        handleModal,
        modalConfig,
        handleRowActions,
        handlePagination
    } = useNotes();

    const { dateFormatter } = useDateHandler();
    const { t } = useTranslation();

    const [expandedNoteId, setExpandedNoteId] = useState(null);

    const toggleExpand = (id) => {
        setExpandedNoteId((prevId) => (prevId === id ? null : id));
    };

    return (
        <LoaderOverlay
            active={loading}
            children={
                <>
                    <Flex justify="between">
                        <h3>{t("Notes")}</h3>
                        <LoadingButton
                            className="details-page-add-button"
                            text="Add Note"
                            icon="plus"
                            subject="companies"
                            onClick={() => handleModal()}/>
                    </Flex>

                    {size(notes) ? (
                        notes.map((note) => {
                            const isExpanded = expandedNoteId === note.id;
                            return (
                                <Card containerClass="mt-1" key={note.id}>
                                    <div>
                                        <Flex
                                            justify="between"
                                            align="center"
                                            onClick={() => toggleExpand(note.id)}>
                                            <h3 className="text-primary fs-3 cursor-pointer">{note.title}</h3>
                                            <Flex onClick={(e) => e.stopPropagation()}>
                                                <LoadingButton
                                                    outline
                                                    color="info"
                                                    onClick={() => handleRowActions(note)}
                                                    icon="pencil"/>
                                                <LoadingButton
                                                    onClick={() => handleRowActions(note, "delete")}
                                                    color="danger"
                                                    outline
                                                    icon="delete"/>
                                            </Flex>
                                        </Flex>

                                        {isExpanded && (
                                            <>
                                                <div className="mt-1">
                                                    {note.desc?.split("\n").map((line, index) => (
                                                        <p key={index}>{line.trim()}</p>
                                                    ))}
                                                </div>

                                                <div className="border-top pt-1 mt-1">
                                                    <p>
                                                        <b>{t("Created By:")} </b>
                                                        {capitalize(note.createdBy.name)}
                                                    </p>
                                                    <p>
                                                        <b>{t("Created At:")} </b>
                                                        {dateFormatter({
                                                            date    : note.createdAt,
                                                            formatAs: "MMM DD, YYYY hh:mm A"
                                                        })}
                                                    </p>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </Card>
                            );
                        })
                    ) : (
                        <div className="w-100">
                            <NoDataComponent />
                        </div>
                    )}
                    {size(notes) > 0 && (
                        <div className="mt-1">
                            <Paginate
                                paginationRowsPerPageOptions={ROW_PER_PAGINATION_OPTIONS}
                                handlePageChange={(page) => handlePagination({ page, limit: pagination?.limit || 10 })}
                                currentPage={pagination?.page}
                                handleLimit={(limit) => handlePagination({ limit, page: 1 })}
                                totalRecords={pagination?.totalRecords}
                                {...pagination}/>
                        </div>
                    )}
                    <UpsertNotes
                        macros={macros}
                        modalConfig={modalConfig}
                        handleModal={handleModal}
                        getAllNotes={getAllNotes}/>
                </>
            }/>
    );
};

export default Notes;
